import {
    FetchUserDocument,
    FetchUserQuery
} from '../../queries/user.generated';
import { fetchGraphql } from '@zoopla/fetch-graphql';

export const getUser = async () => {
    const { data, errors } = await fetchGraphql<FetchUserQuery>(
        FetchUserDocument
    );

    if (process.env.NODE_ENV !== 'production' && errors) {
        console.error(errors);
    }

    return data?.user;
};
